/* Prime Armor — Premium Animations JS v2 */
(function () {
  'use strict';

  /* ================================================
     PAGE LOADER
     ================================================ */
  var loader = document.createElement('div');
  loader.id = 'pa-loader';
  loader.innerHTML =
    '<div class="pa-loader-logo"><span>PRIME</span>ARMOR</div>' +
    '<div class="pa-loader-bar"></div>';
  document.body.prepend(loader);

  function hideLoader() {
    loader.classList.add('hidden');
    setTimeout(function () { loader.remove(); }, 700);
  }
  if (document.readyState === 'complete') {
    setTimeout(hideLoader, 600);
  } else {
    window.addEventListener('load', function () { setTimeout(hideLoader, 400); });
  }

  /* ================================================
     SCROLL PROGRESS
     ================================================ */
  var prog = document.createElement('div');
  prog.id = 'scroll-progress';
  document.body.prepend(prog);
  window.addEventListener('scroll', function () {
    var h = document.documentElement;
    prog.style.width = ((h.scrollTop / (h.scrollHeight - h.clientHeight)) * 100) + '%';
  }, { passive: true });

  /* ================================================
     SPOTLIGHT CURSOR
     ================================================ */
  var spotlight = document.createElement('div');
  spotlight.id = 'pa-spotlight';
  document.body.prepend(spotlight);
  var sx = window.innerWidth / 2, sy = window.innerHeight / 2;
  var cx = sx, cy = sy;
  document.addEventListener('mousemove', function (e) { sx = e.clientX; sy = e.clientY; });
  (function animSpot() {
    cx += (sx - cx) * 0.08;
    cy += (sy - cy) * 0.08;
    spotlight.style.left = cx + 'px';
    spotlight.style.top = cy + 'px';
    requestAnimationFrame(animSpot);
  })();

  /* ================================================
     PARTICLES (hero)
     ================================================ */
  var hero = document.querySelector('.hero');
  if (hero) {
    var canvas = document.createElement('canvas');
    canvas.id = 'pa-particles';
    hero.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var particles = [];
    var W, H;

    function resizeCanvas() {
      W = canvas.width = hero.offsetWidth;
      H = canvas.height = hero.offsetHeight;
    }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    for (var i = 0; i < 60; i++) {
      particles.push({
        x: Math.random() * 1200,
        y: Math.random() * 800,
        r: Math.random() * 1.5 + 0.3,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        o: Math.random() * 0.5 + 0.1
      });
    }

    function drawParticles() {
      ctx.clearRect(0, 0, W, H);
      particles.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0) p.x = W;
        if (p.x > W) p.x = 0;
        if (p.y < 0) p.y = H;
        if (p.y > H) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(79,142,247,' + p.o + ')';
        ctx.fill();
      });

      /* draw lines between close particles */
      for (var a = 0; a < particles.length; a++) {
        for (var b = a + 1; b < particles.length; b++) {
          var dx = particles[a].x - particles[b].x;
          var dy = particles[a].y - particles[b].y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 120) {
            ctx.beginPath();
            ctx.moveTo(particles[a].x, particles[a].y);
            ctx.lineTo(particles[b].x, particles[b].y);
            ctx.strokeStyle = 'rgba(79,142,247,' + (0.08 * (1 - dist / 120)) + ')';
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }
      requestAnimationFrame(drawParticles);
    }
    drawParticles();
  }

  /* ================================================
     GLITCH — set data-text on accent
     ================================================ */
  var accent = document.querySelector('.hero-title .accent');
  if (accent) {
    accent.setAttribute('data-text', accent.textContent);
  }

  /* ================================================
     ANNOUNCEMENT BAR TICKER
     ================================================ */
  var annBar = document.querySelector('.announcement-bar');
  if (annBar) {
    var inner = annBar.innerHTML;
    annBar.innerHTML =
      '<div class="announcement-bar-inner">' +
      '<span>' + inner + '</span>&nbsp;&nbsp;&nbsp;\u2022&nbsp;&nbsp;&nbsp;' +
      '<span aria-hidden="true">' + inner + '</span>&nbsp;&nbsp;&nbsp;\u2022&nbsp;&nbsp;&nbsp;' +
      '</div>';
  }

  /* ================================================
     SCROLL REVEAL
     ================================================ */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });

    /* section lines */
    document.querySelectorAll('.section-line').forEach(function (l) {
      var lo = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('revealed'); lo.unobserve(e.target); }
        });
      }, { threshold: 0.5 });
      lo.observe(l);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('revealed'); });
  }

  /* ================================================
     PRODUCT CARD 3D TILT
     ================================================ */
  document.querySelectorAll('.product-card').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width - 0.5) * 10;
      var y = ((e.clientY - r.top) / r.height - 0.5) * 10;
      card.style.transform = 'perspective(800px) rotateX(' + (-y) + 'deg) rotateY(' + x + 'deg) translateY(-6px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });

  /* ================================================
     BUTTON RIPPLE
     ================================================ */
  document.querySelectorAll('.btn--primary, .btn-add-cart, .btn--outline').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var r = btn.getBoundingClientRect();
      var rip = document.createElement('span');
      rip.className = 'btn-ripple';
      var size = Math.max(r.width, r.height) * 2;
      rip.style.cssText =
        'width:' + size + 'px;height:' + size + 'px;' +
        'left:' + (e.clientX - r.left - size/2) + 'px;' +
        'top:' + (e.clientY - r.top - size/2) + 'px;';
      btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.appendChild(rip);
      setTimeout(function () { rip.remove(); }, 700);
    });
  });

  /* ================================================
     MAGNETIC BUTTONS
     ================================================ */
  document.querySelectorAll('.btn--primary, .btn-add-cart').forEach(function (btn) {
    btn.addEventListener('mousemove', function (e) {
      var r = btn.getBoundingClientRect();
      var x = (e.clientX - r.left - r.width / 2) * 0.3;
      var y = (e.clientY - r.top - r.height / 2) * 0.3;
      btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.transform = '';
    });
  });

  /* ================================================
     STATS COUNTER
     ================================================ */
  document.querySelectorAll('.stat-number').forEach(function (el) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(el);
        var text = el.textContent.trim();
        var num = parseFloat(text.replace(/[^\d.]/g, ''));
        if (!num) return;
        var prefix = text.includes('+') ? '+' : '';
        var suffix = text.replace(/[\d.+,]/g, '').trim();
        var start = performance.now();
        var dur = 2000;
        var isFloat = text.includes('.');
        function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          var ease = 1 - Math.pow(1 - p, 4);
          var val = isFloat ? (ease * num).toFixed(1) : Math.floor(ease * num);
          el.textContent = prefix + val + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    obs.observe(el);
  });

  /* ================================================
     PARALLAX ON SCROLL
     ================================================ */
  var heroImgWrap = document.querySelector('.hero-image-wrap');
  if (heroImgWrap) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY * 0.1;
      heroImgWrap.style.marginTop = y + 'px';
    }, { passive: true });
  }

  /* ================================================
     STAGGER DATA CHILDREN
     ================================================ */
  document.querySelectorAll('[data-stagger]').forEach(function (parent) {
    Array.from(parent.children).forEach(function (child, i) {
      child.setAttribute('data-reveal', '');
      child.setAttribute('data-reveal-delay', String(Math.min(i + 1, 5)));
    });
  });

})();
